import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseMaterialColorPickerModule } from '@fuse/components/material-color-picker/material-color-picker.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogAlertComponent } from './dialog-alert.component';

@NgModule({
  entryComponents: [
    DialogAlertComponent
  ],
  declarations: [
    DialogAlertComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,
    FuseMaterialColorPickerModule,

    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatToolbarModule
  ],
  exports: [
    DialogAlertComponent
  ],
})
export class DialogAlertModule { }
